/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Observable, BehaviorSubject } from 'rxjs';

export class Store<T> {
  public state$: Observable<T>;

  private state$$: BehaviorSubject<T>;

  protected constructor(initialState: T) {
    this.state$$ = new BehaviorSubject(initialState);
    this.state$ = this.state$$.asObservable();
  }

  get state(): T {
    return this.state$$.getValue();
  }

  setState(nextState: T): void {
    this.state$$.next(nextState);
  }
}
